/**
 * UMD / IIFE entry. Bundled with CSS inlined and React tree-shaken out,
 * intended for `<script src="...stash-pay.umd.min.js">`.
 *
 * After loading, the global looks like:
 *   window.StashPay.open({...})
 *   window.StashPay.Controller
 *   window.StashPay.injectStyles()
 *   window.StashPay.preconnect('https://checkout...')
 *   window.StashPay.version
 *
 * Implementation note: only named exports are used here so tsup/esbuild's IIFE
 * format (`globalName: 'StashPay'`) lands each method directly on the global.
 * A `default` export would land under `window.StashPay.default`.
 */

import {
  StashPayController,
  open as controllerOpen,
  StashPayError,
} from '../core/controller';
import { injectStyles as injectStylesFn } from '../core/styles-inject';
import { preconnect as preconnectFn } from '../core/preconnect';

// Auto-inject styles on load. Replaced inline at build time via tsup `define`.
if (typeof document !== 'undefined') injectStylesFn();

// Build-time define — string literal injected by tsup.
declare const __STASH_PAY_VERSION__: string;

export const open = controllerOpen;
export { StashPayController as Controller, StashPayError };
export const injectStyles = injectStylesFn;
export const preconnect = preconnectFn;
export const version: string = __STASH_PAY_VERSION__;
